@if (form) {
  <form [formGroup]="form" class="flex flex-col gap-y-6">
    <div class="flex flex-col gap-y-6 md:flex-row md:gap-6">
      <div
        class="basis-1/2"
        [ngClass]="{ 'g-control-invalid group': validationShouldBeShown(form.controls.firstName) }"
        e2e-question-code="firstName"
        e2e-render-type="text-input"
      >
        <label cslLabel [required]="true" for="firstName" class="mx-2 mb-1"> First Name </label>

        <input
          cslInput
          id="firstName"
          type="text"
          placeholder="Enter first name"
          formControlName="firstName"
          maxlength="35"
          [attr.aria-invalid]="validationShouldBeShown(form.controls.firstName) ? 'true' : null"
          [attr.aria-describedby]="validationShouldBeShown(form.controls.firstName) ? errorIds.firstName : null"
        />

        @if (validationShouldBeShown(form.controls.firstName)) {
          <csl-validation-messages
            class="ml-1"
            [errors]="form.controls.firstName.errors"
            [attr.id]="errorIds.firstName"
            aria-live="polite"
          >
            <csl-validation-message name="required"> {{ errorMessages.firstName['required'] }} </csl-validation-message>
            <csl-validation-message name="minlength">
              {{ errorMessages.firstName['minlength'] }}
            </csl-validation-message>
            <csl-validation-message name="pattern"> {{ errorMessages.firstName['pattern'] }} </csl-validation-message>
          </csl-validation-messages>
        }
      </div>

      <div
        class="basis-1/2"
        [ngClass]="{ 'g-control-invalid group': validationShouldBeShown(form.controls.lastName) }"
        e2e-question-code="lastName"
        e2e-render-type="text-input"
      >
        <label cslLabel [required]="true" for="lastName" class="mx-2 mb-1"> Last Name </label>
        <input
          cslInput
          id="lastName"
          type="text"
          placeholder="Enter last name"
          formControlName="lastName"
          maxlength="35"
          [attr.aria-invalid]="validationShouldBeShown(form.controls.lastName) ? 'true' : null"
          [attr.aria-describedby]="validationShouldBeShown(form.controls.lastName) ? errorIds.lastName : null"
        />

        @if (validationShouldBeShown(form.controls.lastName)) {
          <csl-validation-messages
            class="ml-1"
            [errors]="form.controls.lastName.errors"
            [attr.id]="errorIds.lastName"
            aria-live="polite"
          >
            <csl-validation-message name="required"> {{ errorMessages.lastName['required'] }} </csl-validation-message>
            <csl-validation-message name="minlength">
              {{ errorMessages.lastName['minlength'] }}
            </csl-validation-message>
            <csl-validation-message name="pattern"> {{ errorMessages.lastName['pattern'] }} </csl-validation-message>
          </csl-validation-messages>
        }
      </div>
    </div>

    <div
      [ngClass]="{ 'g-control-invalid group': isValidationShouldBeShown(form.controls.phone) }"
      e2e-question-code="phoneNumber"
      e2e-render-type="phone"
    >
      <label cslLabel [required]="true" for="phone" class="mx-2 mb-1"> Phone Number </label>
      <input
        cslInput
        [forceDisabled]="isDisabled()"
        id="phone"
        [showMaskTyped]="true"
        prefix="+1 "
        [specialCharacters]="[' ', '(', ')', '-']"
        shownMaskExpression="(___) ___-____"
        mask="(000) 000-0000"
        type="tel"
        formControlName="phone"
        [validation]="true"
        [attr.aria-invalid]="isValidationShouldBeShown(form.controls.phone) ? 'true' : null"
        [attr.aria-describedby]="isValidationShouldBeShown(form.controls.phone) ? errorIds.phone : null"
      />

      @if (isValidationShouldBeShown(form.controls.phone)) {
        <csl-validation-messages
          class="ml-1"
          [errors]="form.controls.phone.errors"
          [attr.id]="errorIds.phone"
          aria-live="polite"
        >
          <csl-validation-message name="required"> {{ errorMessages.phone['required'] }} </csl-validation-message>
          <csl-validation-message name="mask"> {{ errorMessages.phone['mask'] }} </csl-validation-message>
        </csl-validation-messages>
      }
    </div>

    <div
      [ngClass]="{ 'g-control-invalid group': isValidationShouldBeShown(form.controls.email) }"
      e2e-question-code="email"
      e2e-render-type="email"
    >
      <label cslLabel [required]="true" for="email" class="mx-2 mb-1"> Email </label>
      <input
        cslInput
        [cslInputPattern]="emailPattern"
        id="email"
        type="email"
        placeholder="Enter email"
        formControlName="email"
        maxlength="320"
        [attr.aria-invalid]="isValidationShouldBeShown(form.controls.email) ? 'true' : null"
        [attr.aria-describedby]="isValidationShouldBeShown(form.controls.email) ? errorIds.email : null"
      />

      @if (isValidationShouldBeShown(form.controls.email)) {
        <csl-validation-messages
          class="ml-1"
          [errors]="form.controls.email.errors"
          [attr.id]="errorIds.email"
          aria-live="polite"
        >
          <csl-validation-message name="required"> {{ errorMessages.email['required'] }} </csl-validation-message>
          <csl-validation-message name="pattern"> {{ errorMessages.email['pattern'] }} </csl-validation-message>
        </csl-validation-messages>
      }
    </div>

    <div class="ml-2" e2e-question-code="preferredWayOfCommunication" e2e-render-type="radio-button">
      <label class="block mb-2 text-sm font-medium text-gray-750" id="preferred-contact-method-label">
        Preferred Way of Communication
      </label>

      <mat-radio-group [formControlName]="'preferredContactMethod'" aria-labelledby="preferred-contact-method-label">
        <div class="flex flex-col items-start gap-2">
          <csl-mat-radio
            [disabled]="isDisabled()"
            [value]="contactMethod.email"
            class="flex gap-2 px-2"
            sharpCorners="true"
          >
            Email
          </csl-mat-radio>

          <csl-mat-radio
            [disabled]="isDisabled()"
            [value]="contactMethod.phone"
            class="flex gap-2 px-2"
            sharpCorners="true"
          >
            Phone call
          </csl-mat-radio>
        </div>
      </mat-radio-group>
    </div>

    @if ((!showHolder && !isDisabled()) || (showHolder && isDisabled())) {
      <div class="flex">
        <button
          #additionalHolderButton
          class="group self-start !p-0"
          cslButton="secondary-link"
          type="button"
          e2e-render-type="expandable-group"
          e2e-question-code="additionalAccountHolder"
          e2e-data-state="collapsed"
          [attr.aria-controls]="!isDisabled() ? 'additional-account-holder-section' : null"
          [attr.aria-expanded]="!isDisabled() ? showHolder : null"
          [ngClass]="{
            'text-[--action-disabled-icon-color]': isDisabled(),
            'cursor-pointer text-[--action-icon-color]': !isDisabled(),
          }"
          (click)="addHolder()"
          [disabled]="isDisabled()"
        >
          @if (!isDisabled()) {
            <csl-icon
              name="plus"
              class="text-xl focus:bg-focus group-hover:bg-focus group-focus:bg-focus size-6"
            ></csl-icon>
          }
          Additional Account Holder
        </button>
      </div>
    }

    @if (showHolder) {
      <fieldset id="additional-account-holder-section" class="flex flex-col gap-y-6">
        @if (!isDisabled()) {
          <legend class="sr-only" aria-labelledby="additional-account-holder-description"></legend>
          <p class="text-base font-normal text-gray-750" id="additional-account-holder-description">
            Add an additional account holder who can help manage your services
          </p>
        }

        <div>
          <div class="flex flex-col gap-y-6 md:flex-row md:gap-6">
            <div
              class="basis-1/2"
              [ngClass]="{ 'g-control-invalid group': validationShouldBeShown(form.controls.firstNameHolder) }"
              e2e-render-type="text-input"
              e2e-question-code="firstNameHolder"
            >
              <label cslLabel for="firstNameHolder" class="mx-2 mb-1"> First Name </label>

              <input
                #firstNameHolderInput
                cslInput
                id="firstNameHolder"
                type="text"
                placeholder="Enter first name"
                formControlName="firstNameHolder"
                maxlength="35"
                [attr.aria-invalid]="validationShouldBeShown(form.controls.firstNameHolder) ? 'true' : null"
                [attr.aria-describedby]="
                  validationShouldBeShown(form.controls.firstNameHolder) ? errorIds.firstNameHolder : null
                "
              />

              @if (validationShouldBeShown(form.controls.firstNameHolder)) {
                <csl-validation-messages
                  class="ml-1"
                  [errors]="form.controls.firstNameHolder.errors"
                  [attr.id]="errorIds.firstNameHolder"
                  aria-live="polite"
                >
                  <csl-validation-message name="minlength">
                    {{ errorMessages.firstNameHolder['minlength'] }}
                  </csl-validation-message>
                  <csl-validation-message name="pattern">
                    {{ errorMessages.firstNameHolder['pattern'] }}
                  </csl-validation-message>
                </csl-validation-messages>
              }
            </div>

            <div
              class="basis-1/2"
              [ngClass]="{ 'g-control-invalid group': validationShouldBeShown(form.controls.lastNameHolder) }"
              e2e-render-type="text-input"
              e2e-question-code="lastNameHolder"
            >
              <label cslLabel for="lastNameHolder" class="mx-2 mb-1"> Last Name </label>
              <input
                cslInput
                id="lastNameHolder"
                type="text"
                placeholder="Enter last name"
                formControlName="lastNameHolder"
                maxlength="35"
                [attr.aria-invalid]="validationShouldBeShown(form.controls.lastNameHolder) ? 'true' : null"
                [attr.aria-describedby]="
                  validationShouldBeShown(form.controls.lastNameHolder) ? errorIds.lastNameHolder : null
                "
              />

              @if (validationShouldBeShown(form.controls.lastNameHolder)) {
                <csl-validation-messages
                  class="ml-1"
                  [errors]="form.controls.lastNameHolder.errors"
                  [attr.id]="errorIds.lastNameHolder"
                  aria-live="polite"
                >
                  <csl-validation-message name="minlength">
                    {{ errorMessages.lastNameHolder['minlength'] }}
                  </csl-validation-message>
                  <csl-validation-message name="pattern">
                    {{ errorMessages.lastNameHolder['pattern'] }}
                  </csl-validation-message>
                </csl-validation-messages>
              }
            </div>
          </div>
          @if (showSupportiveText()) {
            <div class="text-gray-750 mt-1.5 text-xs">
              English letters (A–Z), hyphens (-), apostrophes ('), and spaces only. Maximum 35 characters.
            </div>
          }
        </div>

        <div
          [ngClass]="{ 'g-control-invalid group': isValidationShouldBeShown(form.controls.phoneHolder) }"
          e2e-render-type="phone"
          e2e-question-code="phoneHolder"
        >
          <label cslLabel for="phoneHolder" class="mx-2 mb-1"> Phone Number </label>
          <input
            cslInput
            [forceDisabled]="isDisabled()"
            id="phoneHolder"
            [showMaskTyped]="true"
            prefix="+1 "
            [specialCharacters]="[' ', '(', ')', '-']"
            shownMaskExpression="(___) ___ - ____"
            mask="(000) 000 - 0000"
            type="tel"
            formControlName="phoneHolder"
            [validation]="true"
            [attr.aria-invalid]="isValidationShouldBeShown(form.controls.phoneHolder) ? 'true' : null"
            [attr.aria-describedby]="isValidationShouldBeShown(form.controls.phoneHolder) ? errorIds.phoneHolder : null"
          />

          @if (isValidationShouldBeShown(form.controls.phoneHolder)) {
            <csl-validation-messages
              class="ml-1"
              [errors]="form.controls.phoneHolder.errors"
              [attr.id]="errorIds.phoneHolder"
              aria-live="polite"
            >
              <csl-validation-message name="mask"> {{ errorMessages.phoneHolder['mask'] }} </csl-validation-message>
            </csl-validation-messages>
          }
        </div>
        @if (!isDisabled()) {
          <button
            class="group self-start !p-0"
            cslButton="secondary-link"
            type="button"
            e2e-render-type="expandable-group"
            e2e-question-code="additionalAccountHolder"
            e2e-data-state="expanded"
            (click)="removeHolder()"
          >
            <csl-icon
              class="text-xl bg-blue-900 group-hover:bg-focus group-focus:bg-focus size-6"
              [name]="'trash'"
            />
            Remove Additional Account Holder
          </button>
        }
      </fieldset>
    }
  </form>
}
